import { gql } from "@apollo/client";

export const Get_Reports = gql`
  query GetReports(
    $skip: Int
    $take: Int
    $where: ReportFilterInput
    $order: [ReportSortInput!]
  ) {
    reports(skip: $skip, take: $take, where: $where, order: $order) {
      totalCount
      items {
        id
        name
        reportTemplateId
        filterJson
        createdOn
        modifiedOn
        isFavourite
        isDeleted
        createdBy
        lastViewed
        displayName
        categoryId
        displayCategoryName
        dashboardId
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;
export const Get_Favorite_Reports = gql`
  query GetFavReports(
    $userId: Int!
    $skip: Int
    $take: Int
    $where: ReportFilterInput
    $order: [ReportSortInput!]
  ) {
    favoriteReports(
      userId: $userId
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        id
        name
        reportTemplateId
        displayCategoryName
        filterJson
        createdOn
        modifiedOn
        isFavourite
        isDeleted
        createdBy
        lastViewed
        displayName
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const Get_Favorite_Count_Reports = gql`
  query GetFavReports(
    $userId: Int!
    $skip: Int
    $take: Int
    $where: ReportFilterInput
    $order: [ReportSortInput!]
  ) {
    favoriteReports(
      userId: $userId
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        id
      }
    }
  }
`;
export const Get_Report_Templates = gql`
  query GetReportTemplates(
    $skip: Int
    $take: Int
    $where: ReportTemplateFilterInput
    $order: [ReportTemplateSortInput!]
  ) {
    reportTemplates(skip: $skip, take: $take, where: $where, order: $order) {
      totalCount
      items {
        id
        name
        uuid
        createdOn
        modifiedOn
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

// ================= Dashboard Queries =====================

export const Get_Dashboards = gql`
  query GetDashboards(
    $skip: Int
    $take: Int
    $where: DashboardFilterInput
    $order: [DashboardSortInput!]
  ) {
    dashboards(skip: $skip, take: $take, where: $where, order: $order) {
      totalCount
      items {
        id
        name
        createdOn
        userDisplayName
        dashboardTemplateType
        createdBy
        reports {
          id
          name
          reportTemplateId
          filterJson
          createdOn
          isDeleted
        }
      }
    }
  }
`;

export const Get_Dashboards_Count = gql`
  query {
    dashboards {
      totalCount
    }
  }
`;

export const Get_Default_Dashboard = gql`
  query GetDefaultDashboard($id: Int) {
    dashboards(where: { id: { eq: $id } }) {
      totalCount
    }
  }
`;

// ======================reports templates queries
export const Recent_Activity_Created_Leads = gql`
  query RecentActivityCreatedLeads(
    $skip: Int
    $take: Int
    $where: ActivityOfRecentlyCreatedLeadsFilterInput
    $order: [ActivityOfRecentlyCreatedLeadsSortInput!]
  ) {
    recentActivityCreatedLeads(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      items {
        leadId
        leadName
        leadStatusChangedBy
        leadStatusChangedOn
        leadStatus
        companyKey
        leadSourceId
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;
export const Get_Abandoned_Leads = gql`
  query GetAbandonedLeads(
    $skip: Int
    $take: Int
    $where: AbandonedLeadFilterInput
    $order: [AbandonedLeadSortInput!]
  ) {
    abandonedLeadReport(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        companyKey
        leadId
        firstName
        lastName
        dateCreated
        modifiedOn
        lastActivityDate
      }
    }
  }
`;
export const Get_Unassigned_Leads = gql`
  query GetUnassignedLeads(
    $skip: Int
    $take: Int
    $where: UnassignedLeadsFilterInput
    $order: [UnassignedLeadsSortInput!]
  ) {
    unassignedLeadsReport(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        id
        leadName
        createdBy
        createdOn
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const Get_Leads_By_Location = gql`
  query GetLeadsByLocation(
    $fetchAll: Boolean! = false
    $skip: Int
    $take: Int
    $where: LeadsByLocationFilterInput
    $order: [LeadsByLocationSortInput!]
  ) {
    leadsByLocationReport(
      skip: $skip
      take: $take
      where: $where
      order: $order
      fetchAll: $fetchAll
    ) {
      countryId
      stateProvinceId
      city
      leadCount
      leadCreatedOnDateOnly
    }
  }
`;

export const Get_Leads_Generated = gql`
  query GetLeadsGenerated(
    $skip: Int
    $take: Int
    $where: LeadsGeneratedFilterInput
    $order: [LeadsGeneratedSortInput!]
  ) {
    leadsGeneratedReport(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        leadId
        leadName
        phone
        email
        leadStatusId
        createdOn
        leadSourceId
      }
    }
  }
`;
export const Get_Leads_Contacted_By_Team_Member = gql`
  query GetLeadsContactedByTeamMember(
    $skip: Int
    $take: Int
    $where: LeadsContactedByTeamMemberFilterInput
    $order: [LeadsContactedByTeamMemberSortInput!]
  ) {
    leadsContactedByTeamMemberReport(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        leadId
        leadSourceId
        leadStatusId
        teamMemberId
        overTime
      }
    }
  }
`;
export const Get_Avg_Lead_Response_Time = gql`
  query GetAvgLeadResponseTime(
    $skip: Int
    $take: Int
    $where: AvgLeadResponseTimeFilterInput
    $order: [AvgLeadResponseTimeSortInput!]
  ) {
    avgLeadResponseTimeReport(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        outreachType
        avgResponseTimeMinutes
        leadStatusId
        leadOwnerId
        totalLeads
        firstOutreachTime
      }
    }
  }
`;
export const Get_Mql_Leads_By_First_Outreach = gql`
  query GetMqlLeadsByFirstOutreach(
    $skip: Int
    $take: Int
    $where: MQLLeadsByFirstOutreachFilterInput
    $order: [MQLLeadsByFirstOutreachSortInput!]
  ) {
    mqlLeadsByFirstOutreachReport(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        leadId
        leadSourceId
        qualifiedLead
        teamMemberId
        overTime
        countryId
        stateProvinceId
        city
        qualifiedLead
      }
    }
  }
`;
export const Get_Email_Conversations_OverTime = gql`
  query GetEmailConversationsOverTime(
    $skip: Int
    $take: Int
    $where: EmailConversationsOverTimeFilterInput
    $order: [EmailConversationsOverTimeSortInput!]
  ) {
    emailConversationsOverTime(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        leadId
        messageId
        leadSourceId
        teamMemberId
        emailSentDate
      }
    }
  }
`;
export const Get_Leads_Not_Contacted = gql`
  query GetLeadsNotContacted(
    $skip: Int
    $take: Int
    $where: LeadsNotContactedFilterInput
    $order: [LeadsNotContactedSortInput!]
  ) {
    leadsNotContactedReport(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        leadId
        leadName
        assignedTo
        dateOfLeadGeneration
        leadSourceId
      }
    }
  }
`;

export const Get_Avg_Email_Open_Rate = gql`
  query GetAvgEmailOpenRate(
    $skip: Int
    $take: Int
    $where: AvgEmailOpenRateFilterInput
    $order: [AvgEmailOpenRateSortInput!]
  ) {
    avgEmailOpenRateReport(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        companyKey
        leadId
        leadSourceId
        industryId
        countryId
        stateProvinceId
        city
        emailSentDate
        openRate
      }
    }
  }
`;

export const Get_Active_Workflows_Activity = gql`
  query GetActiveWorkflowsActivity(
    $fetchAll: Boolean! = false
    $skip: Int
    $take: Int
    $where: ActiveWorkflowsActivityFilterInput
    $order: [ActiveWorkflowsActivitySortInput!]
  ) {
    activeWorkflowsActivityReport(
      skip: $skip
      take: $take
      where: $where
      order: $order
      fetchAll: $fetchAll
    ) {
      workFlowId
      activityType
      activityTypeId
      leadCount
      activityDate
    }
  }
`;
export const Get_Active_Workflow_With_Leads = gql`
  query GetActiveWorkflowWithLeads(
    $skip: Int
    $take: Int
    $where: ActiveWorkflowsWithLeadsFilterInput
    $order: [ActiveWorkflowsWithLeadsSortInput!]
  ) {
    activeWorkflowsWithLeadsReport(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        workflowName
        workflowCreatedOn
        numberOfLeadsEnrolled
        companyKey
      }
    }
  }
`;

export const Get_Workflows_With_Email_Template = gql`
  query GetWorkflowsWithEmailTemplate(
    $skip: Int
    $take: Int
    $where: WorkflowsWithEmailTemplateFilterInput
    $order: [WorkflowsWithEmailTemplateSortInput!]
  ) {
    workflowsWithEmailTemplateReport(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        workflowName
        createdBy
        templateName
        createdOn
      }
    }
  }
`;
export const Get_Workflows_With_SMS_Template = gql`
  query GetWorkflowWithSMSTemplate(
    $skip: Int
    $take: Int
    $where: WorkflowWithSMSTemplateFilterInput
    $order: [WorkflowWithSMSTemplateSortInput!]
  ) {
    workflowWithSMSTemplatesReport(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        workflowName
        createdBy
        templateName
        createdOn
      }
    }
  }
`;

export const Get_Task_Status = gql`
  query GetTaskStatusReport(
    $skip: Int
    $take: Int
    $where: TaskStatusSummaryFilterInput
    $order: [TaskStatusSummarySortInput!]
  ) {
    taskStatusReport(skip: $skip, take: $take, where: $where, order: $order) {
      totalCount
      items {
        statusName
        taskTypeId
        assignedTo
        dueDate
        taskCount
      }
    }
  }
`;
export const Get_Task_Volume_By_Type = gql`
  query GetTaskVolumeByTypeReport(
    $skip: Int
    $take: Int
    $where: TaskVolumeByTypeFilterInput
    $order: [TaskVolumeByTypeSortInput!]
  ) {
    taskVolumeByTypeReport(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        taskTypeName
        taskCount
        percentage
        createdOn
        assignedTo
        leadId
      }
    }
  }
`;

export const Get_Lead_Lists_In_Workflows = gql`
  query GetLeadListsInWorkflows(
    $skip: Int
    $take: Int
    $where: LeadListsInWorkflowsFilterInput
    $order: [LeadListsInWorkflowsSortInput!]
  ) {
    leadListsInWorkflowsReport(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        leadList
        createdOn
        createdBy
        workflowUsedIn
        companyKey
      }
    }
  }
`;

export const Get_SMS_Sent = gql`
  query GetSMSSentReport(
    $skip: Int
    $take: Int
    $where: SMSSentFilterInput
    $order: [SMSSentSortInput!]
  ) {
    smsSentReport(skip: $skip, take: $take, where: $where, order: $order) {
      totalCount
      items {
        leadId
        leadName
        leadSourceId
        city
        status
        createdOn
      }
    }
  }
`;
export const Get_SMS_Received = gql`
  query GetSMSReceivedReport(
    $skip: Int
    $take: Int
    $where: SMSReceivedFilterInput
    $order: [SMSReceivedSortInput!]
  ) {
    smsReceivedReport(skip: $skip, take: $take, where: $where, order: $order) {
      totalCount
      items {
        leadId
        leadName
        createdOn
        city
      }
    }
  }
`;

export const Get_Email_Sent = gql`
  query GetEmailSentReport(
    $skip: Int
    $take: Int
    $where: EmailSentFilterInput
    $order: [EmailSentSortInput!]
  ) {
    emailSentReport(skip: $skip, take: $take, where: $where, order: $order) {
      totalCount
      items {
        leadId
        leadName
        leadSourceId
        countryId
        stateProvinceId
        city
        email
        isOpened
        createdOn
      }
    }
  }
`;

export const Get_Email_Received = gql`
  query GetEmailReceivedReport(
    $skip: Int
    $take: Int
    $where: EmailReceivedFilterInput
    $order: [EmailReceivedSortInput!]
  ) {
    emailReceivedReport(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        leadId
        leadName
        email
        createdOn
        status
        countryId
        stateProvinceId
        city
      }
    }
  }
`;

export const Get_Appointment_Scheduled = gql`
  query GetAppointmentScheduledReport(
    $skip: Int
    $take: Int
    $where: AppointmentScheduledFilterInput
    $order: [AppointmentScheduledSortInput!]
  ) {
    appointmentScheduledReport(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        leadId
        title
        leadName
        leadSourceId
        leadSource
        createdBy
        memberId
        createdOn
        startDate
        endDate
      }
    }
  }
`;

export const Get_Lead_To_Appointment_Ratio_Kpi = gql`
  query GetLeadToAppointmentRatioKpi(
    $where: LeadToAppointmentRatioFilterInput
  ) {
    leadToAppointmentRatioKpi(where: $where, fetchAll: true) {
      appointmentConversionPercent
      totalLeads
      leadsWithAppointments
    }
  }
`;

export const Get_Lead_To_Appointment_Ratio = gql`
  query GetLeadToAppointmentRatio(
    $skip: Int
    $take: Int
    $where: LeadToAppointmentRatioFilterInput
    $order: [LeadToAppointmentRatioSortInput!]
  ) {
    leadToAppointmentRatioReport(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        companyKey
        leadId
        leadName
        appointmentName
        appointmentId
        leadCreatedOn
        assignedTo
        leadSourceId
        leadSource
        countryId
        stateProvinceId
        city
      }
    }
  }
`;
export const Get_Report_Categories = gql`
  query {
    reportTemplateCategory(skip: 0, take: 100, where: { id: { neq: 7 } }) {
      items {
        id
        name
        reportTemplateCategoryMappings {
          reportTemplateId
          categoryId
        }
      }
    }
  }
`;
export const Get_Report_Categories_Basic = gql`
  query {
    reportTemplateCategory(skip: 0, take: 100, where: { id: { eq: 5 } }) {
      items {
        id
        name
        reportTemplateCategoryMappings {
          reportTemplateId
          categoryId
        }
      }
    }
  }
`;
export const Get_Report_Categories_only = gql`
  query {
    reportTemplateCategory(where: { id: { neq: 0 } }) {
      items {
        id
        name
      }
    }
  }
`;

export const Get_Inbound_Calls_Over_Time = gql`
  query GetInboundCallsOverTime(
    $skip: Int
    $take: Int
    $where: InboundCallsOverTimeFilterInput
    $order: [InboundCallsOverTimeSortInput!]
  ) {
    inboundCallsOverTimeReport(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        representativeName
        createdOn
        totalInboundCalls
        totalMinutes
        companyKey
      }
    }
  }
`;
export const Get_Inbound_Calls = gql`
  query GetInboundCalls(
    $skip: Int
    $take: Int
    $where: InboundCallFilterInput
    $order: [InboundCallSortInput!]
  ) {
    inboundCallReport(skip: $skip, take: $take, where: $where, order: $order) {
      totalCount
      items {
        answered
        abandoned
        total
        representativeName
        createdOn
        companyKey
      }
    }
  }
`;
export const Get_Leads_By_Status = gql`
  query GetLeadByStatus(
    $filter: LeadsByStatusPerFilterInput
    $skip: Int
    $take: Int
    $where: LeadsByStatusFilterInput
    $order: [LeadsByStatusSortInput!]
  ) {
    leadsByStatusReport(
      filter: $filter
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        status
        total
        percentage
      }
    }
  }
`;

export const Get_Lead_Status_By_Average_Annual_Revenue = gql`
  query LeadStatusByAverageAnnualRevenue(
    $skip: Int
    $take: Int
    $where: LeadStatusByAverageAnnualRevenueFilterInput
    $order: [LeadStatusByAverageAnnualRevenueSortInput!]
    $startDate: DateTime!
    $endDate: DateTime!
  ) {
    leadStatusByAverageAnnualRevenueReport(
      skip: $skip
      take: $take
      where: $where
      order: $order
      startDate: $startDate
      endDate: $endDate
    ) {
      totalCount
      items {
        leadStatusId
        averageAnnualRevenue
        percentage
        leadsInStatusCount
      }
    }
  }
`;

export const Get_Appointments_Over_Time = gql`
  query GetAppointmentsOvertime($startDate: DateTime, $endDate: DateTime) {
    appointmentsOverTime(startDate: $startDate, endDate: $endDate) {
      bucketDate
      bookedCount
    }
  }
`;

export const Get_Appointments_By_Team_Member_Over_Time = gql`
  query GetAppointmentsByTeamMemberOvertime(
    $startDate: DateTime
    $endDate: DateTime
  ) {
    appointmentsByTeamMemberOverTime(startDate: $startDate, endDate: $endDate) {
      participantId
      participantName
      bucketDate
      appointmentCount
    }
  }
`;
export const Get_Booked_Appointments_Kpi = gql`
  query GetAppointmentsBookedKPI($startDate: DateTime!, $endDate: DateTime!) {
    appointmentsBookedKpi(startDate: $startDate, endDate: $endDate) {
      count
      previousCount
      percentChange
    }
  }
`;

export const Get_Rescheduled_Appointments_Kpi = gql`
  query GetAppointmentsRescheduledKPI(
    $startDate: DateTime!
    $endDate: DateTime!
  ) {
    appointmentsRescheduledKpi(startDate: $startDate, endDate: $endDate) {
      count
      previousCount
      percentChange
    }
  }
`;

export const Get_Canceled_Appointments_Kpi = gql`
  query GetAppointmentsCanceledKPI($startDate: DateTime!, $endDate: DateTime!) {
    appointmentsCanceledKpi(startDate: $startDate, endDate: $endDate) {
      count
      previousCount
      percentChange
    }
  }
`;
